import { useAnalytics } from "@codat/analytics";
import { Switch } from "@codat/orchard-ui";
import type { ToastInfo } from "@codat/orchard-ui/dist/es/components/Toast/types";
import { CodatError } from "api/users";
import { AxiosPromise } from "axios";
import React, { useState } from "react";

import styles from "./ManageLogin.module.css";
import { MappedClientLoginSettings } from "./mapClientLoginSettings";
import { PremiumIcon } from "./PremiumIcon";

interface SettingsRowProps {
  setting: MappedClientLoginSettings;
  addToast: (toastInfo: ToastInfo) => void;
  onToggle: (loginSetting: {
    typeId: number;
    enabled: boolean;
  }) => AxiosPromise<unknown>;
}

const SettingsToggle: React.FC<SettingsRowProps> = ({
  setting,
  addToast,
  onToggle,
}) => {
  const { sendEvent } = useAnalytics();
  const [isEnabled, setIsEnabled] = useState(setting.enabled);
  const settingId = setting.name.replace(" ", "-");

  const toggleSetting = (
    loginSetting: MappedClientLoginSettings,
    enabled: boolean
  ) => {
    setIsEnabled(enabled);

    sendEvent("Sign-in method - Toggled", {
      name: loginSetting.name,
      enabled: enabled,
    });

    onToggle({ typeId: setting.typeId, enabled: enabled })
      .then(() => {
        addToast({
          message: `${enabled ? "Enabled" : "Disabled"} ${loginSetting.name}`,
          variant: "success",
        });
      })
      .catch((error) => {
        const codatError = error.response?.data as CodatError;
        setIsEnabled(!enabled);
        addToast({
          message: `${codatError?.error}`,
          variant: "error",
        });
      });
  };

  return (
    <>
      <div id={`${settingId}-toggle-label`}>{setting.name}</div>
      {setting.restricted && !isEnabled ? (
        <PremiumIcon />
      ) : (
        <Switch
          className={styles.toggle}
          onClick={() => toggleSetting(setting, !isEnabled)}
          isChecked={isEnabled}
          aria-labelledby={`${settingId}-toggle-label`}
          disabled={setting.restricted}
        />
      )}
    </>
  );
};

export default SettingsToggle;
